import { useLocation } from "react-router-dom"

const getNavbarTitle = () => {
  const location = useLocation()
  const title = location.pathname.split('/')[2]

  return camelCaseToSpaces(title)
}

const camelCaseToSpaces = camelCaseWord => {
  if (!camelCaseWord) return

  // Add a space before each uppercase letter and convert it to lowercase
  const spacedString = camelCaseWord.replace(/([a-z])([A-Z])/g, '$1 $2');

  // Capitalize the first letter of each word
  const capitalizedString = spacedString
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return capitalizedString;
}

export default getNavbarTitle